<div class="row">
  <div class="col-md-8 mx-auto text-center">
    <h1>ESQUECI MINHA SENHA</h1>
  </div>
</div>

<div class="card o-hidden mt-5"
  [@animate]="{value:'*',params:{y:'120px',opacity:'0',delay:'100ms', duration: '400ms'}}">
  <div class="row">
    <div class="col-md-10 mx-auto">
      <div class="row">
        <div class="col-md-12 text-center">
          Digite o e-mail cadastrado para recuperar sua senha de acesso
        </div>
      </div>
      <div class="p-4">
        <form [formGroup]="form" (validSubmit)="forgotPassword($event)">
          <div class="row" *ngIf="showError">
            <ngb-alert class="alert-card col-md-12" [type]="'danger'" (close)="closeAlert()">
              <span>{{messageError}}</span>
            </ngb-alert>

          </div>

          <div class="row">
            <div class="col-md-12">
              <mat-form-field>
                <input matInput placeholder="E-MAIL" formControlName="email">
              </mat-form-field>
            </div>
          </div>

          <btn-loading *ngIf="!showSuccess; else showMessageSuccess" btnClass="btn-primary btn-rounded btn-block mt-3"
            [loadingText]="loadingText" [loading]="loading$ | async">
            RECUPERAR
          </btn-loading>
          <ng-template #showMessageSuccess>
            <ngb-alert [dismissible]="false" class="alert-card col-md-12" [type]="'success'">
              <span>Obrigado, em poucos minutos você receberá em seu e-mail um link para registrar uma nova senha.</span>
              <span *ngIf="cellPhone">
                <br />
                <ng-container *ngIf="!sentSMS">Caso prefira receber o link de recuperação de senha via SMS no telefone
                  {{cellPhone}}, <span (click)="sendSMS()" class="cursor-pointer underline">clique aqui</span>.
                </ng-container>
                <ng-container *ngIf="sentSMS">SMS enviado. Clique no link recebido no seu celular para recuperar a
                  senha.
                </ng-container>
              </span>
            </ngb-alert>

          </ng-template>
        </form>
      </div>
    </div>
  </div>
</div>